import * as React from "react";

const ArrowLeftIcon: React.FC = () => {
    return (
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.329348 5.20496L4.82934 0.704956C5.26879 0.265503 5.98071 0.265503 6.42016 0.704956C6.85961 1.14441 6.85961 1.85632 6.42016 2.29578L3.84233 4.87449H16.8747C17.4966 4.87449 17.9997 5.37757 17.9997 5.99949C17.9997 6.6214 17.4966 7.12449 16.8747 7.12449H3.84233L6.42209 9.70425C6.86154 10.1437 6.86154 10.8556 6.42209 11.2951C5.98299 11.7342 5.27108 11.7349 4.83127 11.2951L0.331282 6.79507C-0.110104 6.35457 -0.110104 5.64441 0.329348 5.20496Z" fill="#262525"/>
</svg>
        

    );
};

export default React.memo(ArrowLeftIcon);
